"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkNotes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var __1 = require("../../..");
var react_1 = require("@escolalms/sdk/lib/react");
var react_2 = require("react");
var i18next_1 = require("i18next");
var styles_1 = require("./styles");
var styled_components_1 = __importStar(require("styled-components"));
var BookmarkNotes = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var onClickBookmark = _a.onClickBookmark, onDelete = _a.onDelete;
    var _j = (0, react_2.useState)(1), currentPage = _j[0], setCurrentPage = _j[1];
    var _k = (0, react_2.useState)(2), lastPage = _k[0], setLastPage = _k[1];
    var previousDisabled = currentPage <= 1;
    var nextDisabled = currentPage >= lastPage;
    var _l = (0, react_2.useState)(0), selectedListItem = _l[0], setSelectedListItem = _l[1];
    var _m = (0, react_2.useContext)(react_1.EscolaLMSContext), bookmarkNotes = _m.bookmarkNotes, fetchBookmarkNotes = _m.fetchBookmarkNotes, deleteBookmarkNote = _m.deleteBookmarkNote;
    var bookmarks = (0, react_2.useMemo)(function () { var _a; return (_a = bookmarkNotes.list) === null || _a === void 0 ? void 0 : _a.data.filter(function (item) { return item.value === null; }); }, [(_b = bookmarkNotes.list) === null || _b === void 0 ? void 0 : _b.data]);
    var notes = (0, react_2.useMemo)(function () { var _a; return (_a = bookmarkNotes.list) === null || _a === void 0 ? void 0 : _a.data.filter(function (item) { return item.value; }); }, [(_c = bookmarkNotes.list) === null || _c === void 0 ? void 0 : _c.data]);
    var listItems = [
        {
            id: 0,
            icon: (0, jsx_runtime_1.jsx)(__1.Icon, { name: "editAll" }),
            text: (0, i18next_1.t)("Bookmarks.All"),
            numberOfItems: ((_d = bookmarkNotes.list) === null || _d === void 0 ? void 0 : _d.data.length) || 0,
        },
        {
            id: 1,
            icon: (0, jsx_runtime_1.jsx)(__1.Icon, { name: "editAlt" }),
            text: (0, i18next_1.t)("Bookmarks.Notes"),
            numberOfItems: ((_e = bookmarkNotes.list) === null || _e === void 0 ? void 0 : _e.data.length)
                ? Number(notes === null || notes === void 0 ? void 0 : notes.length)
                : 0,
        },
        {
            id: 2,
            icon: (0, jsx_runtime_1.jsx)(__1.Icon, { name: "edit" }),
            text: (0, i18next_1.t)("Bookmarks.Bookmarks"),
            numberOfItems: ((_f = bookmarkNotes.list) === null || _f === void 0 ? void 0 : _f.data.length)
                ? Number(bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.length)
                : 0,
        },
    ];
    var getArrayToMap = function () {
        var _a;
        switch (selectedListItem) {
            case 0:
                return (_a = bookmarkNotes.list) === null || _a === void 0 ? void 0 : _a.data;
            case 1:
                return notes;
            case 2:
                return bookmarks;
        }
    };
    var handleBookmark = function (id) {
        return deleteBookmarkNote(id).then(function () {
            fetchBookmarkNotes();
            onDelete && onDelete();
        });
    };
    (0, react_2.useEffect)(function () {
        var _a;
        fetchBookmarkNotes({ page: currentPage, per_page: 25 });
        setLastPage(Number((_a = bookmarkNotes.list) === null || _a === void 0 ? void 0 : _a.meta.last_page));
    }, [fetchBookmarkNotes, currentPage]);
    return ((0, jsx_runtime_1.jsxs)(styles_1.BookmarkNotesContainer, { children: [(0, jsx_runtime_1.jsx)(styles_1.BookmarkNotesHeader, { children: (0, jsx_runtime_1.jsx)(__1.Title, __assign({ level: 4 }, { children: (0, i18next_1.t)("Bookmarks.Title") })) }), (0, jsx_runtime_1.jsxs)(styles_1.BookmarkNotesBody, { children: [(0, jsx_runtime_1.jsx)(styles_1.BookmarkNotesMenu, { children: (0, jsx_runtime_1.jsx)(__1.List, { listItems: listItems, selectedListItem: selectedListItem, setSelectedListItem: setSelectedListItem }) }), (0, jsx_runtime_1.jsxs)(styles_1.BookmarkNotesContent, { children: [(0, jsx_runtime_1.jsx)(styles_1.BookmarkNotesList, { children: (_g = getArrayToMap()) === null || _g === void 0 ? void 0 : _g.map(function (item) {
                                    var id = item.id, bookmarkable_type = item.bookmarkable_type, value = item.value;
                                    var bookmarkInfo = bookmarkable_type.split(":");
                                    var bookmark = bookmarkable_type
                                        .split("/")
                                        .map(function (num) { return parseInt(num); });
                                    return ((0, jsx_runtime_1.jsxs)(styles_1.BookmarkNotesItem, { children: [(0, jsx_runtime_1.jsxs)(__1.Stack, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledTitle, __assign({ size: "lg", weight: "medium", onClick: function () {
                                                            return onClickBookmark(bookmark[0], bookmark[1], bookmark[2]);
                                                        } }, { children: "".concat(bookmarkInfo[1], " : ").concat(bookmarkInfo[2]) })), value && (0, jsx_runtime_1.jsx)(styles_1.NoteText, { children: value })] }), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ mode: "outline", onClick: function () { return handleBookmark(id); } }, { children: (0, i18next_1.t)("Bookmarks.Delete") }))] }, id));
                                }) }), ((_h = bookmarkNotes.list) === null || _h === void 0 ? void 0 : _h.data.length) === 0 && ((0, jsx_runtime_1.jsx)(__1.Text, __assign({ weight: "light" }, { children: (0, i18next_1.t)("Bookmarks.NoBookmarks") })))] })] }), (0, jsx_runtime_1.jsxs)(styles_1.BookmarksPage, { children: [(0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: "button", mode: "outline", disabled: previousDisabled, onClick: function () { return setCurrentPage(currentPage - 1); } }, { children: (0, i18next_1.t)("Bookmarks.Prev") })), (0, jsx_runtime_1.jsx)(__1.Title, { children: "".concat((0, i18next_1.t)("Bookmarks.Page"), " ").concat(currentPage, " / ").concat(lastPage || 1) }), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: "button", mode: "outline", disabled: nextDisabled, onClick: function () { return setCurrentPage(currentPage + 1); } }, { children: (0, i18next_1.t)("Bookmarks.Next") }))] })] }));
};
exports.BookmarkNotes = BookmarkNotes;
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(exports.BookmarkNotes)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""]))));
var templateObject_1;
